import {
  defaultHistoryFields,
  isDeletedField
} from "@/components/Tables/defaultFields";
import StringFilterModel from "@/components/Tables/Filters/models/stringFilterModel";

let servicesFields = [
  {
    key: "name",
    label: "Служба",
    filter: new StringFilterModel()
  }
];

const servicesHistoryFields = [...servicesFields, ...defaultHistoryFields];

servicesFields.push(isDeletedField);

export { servicesFields, servicesHistoryFields };
